/** Limite padrão do PostgREST no Supabase por requisição. */
export const SUPABASE_MAX_ROWS_PER_QUERY = 1000

/** Tamanho seguro para listas em `.in()` (URL e limite de linhas por resposta). */
export const SUPABASE_IN_CHUNK_SIZE = 500

type PageError = { message: string } | null

type PageResult<T> = PromiseLike<{ data: T[] | null; error: PageError }>

/**
 * Busca todas as páginas usando `.range(from, to)` em loop até a última página incompleta.
 */
export async function fetchAllByRange<T>(
  fetchPage: (from: number, to: number) => PageResult<T>
): Promise<{ data: T[]; error: string | null }> {
  const acc: T[] = []
  let from = 0

  for (;;) {
    const to = from + SUPABASE_MAX_ROWS_PER_QUERY - 1
    const { data, error } = await fetchPage(from, to)
    if (error) {
      return { data: acc, error: error.message }
    }
    const batch = data ?? []
    acc.push(...batch)
    if (batch.length < SUPABASE_MAX_ROWS_PER_QUERY) {
      break
    }
    from += SUPABASE_MAX_ROWS_PER_QUERY
  }

  return { data: acc, error: null }
}
